import React, { useEffect } from 'react';
import { debounce } from 'lodash';

const options = {
  root: null,
  rootMargin: '0px',
  threshold: 1.0,
};

export const useViewportObserver = (
  elementContentRef: React.RefObject<HTMLDivElement>,
  handleEmmiter: () => void,
  delay: number = 500,
) => {
  const [isVisible, setIsVisible] = React.useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      setIsVisible(entry.isIntersecting);
    }, options);

    if (elementContentRef.current) {
      observer.observe(elementContentRef.current);
    }

    return () => {
      if (elementContentRef.current) {
        observer.unobserve(elementContentRef.current);
      }
    };
  }, [elementContentRef]);

  useEffect(() => {
    const delayEvent = debounce(() => {
      handleEmmiter();
    }, delay);

    if (isVisible) {
      delayEvent();
    }

    return () => {
      delayEvent.cancel();
    };
  }, [isVisible]);

  return isVisible;
};
